export default __webpack_public_path__ + "static/media/PAFI_Ringkasan Risalah_Minutes Summary of EGMS 2025.5c3d57cf.pdf";